/**
 * Splits the provided text by new line characters.
 */
export var splitTextByNewLine = function splitTextByNewLine(text) {
  return text.split(/(?:\r\n?|\n)/);
};